<template>
  <div class="distribution-level">
    <div class="relative" v-min-height>
      <div class="box clearfix">
        <transition-group name="flip-list" tag="div">
          <div class="item" v-for="(item, index) in list" :key="item.numberId">
            <div class="hd">
              <div class="img-level">
                <img
                  :src="item.imgUrl ? item.imgUrl : _staticImg(item.numberId)"
                  alt=""
                />
              </div>
              <div class="operator">
                <h3 class="title">
                  {{ item.name }}
                </h3>
                <p class="tips">
                  {{ item.reviewType | formatCheckType }}
                </p>
                <div class="table-wrapper">
                  <el-button
                    @click="del(item.levelId, index)"
                    size="36"
                    v-permission:del="$route.meta.permission"
                    round
                    class="iconfont icon-shanchu"
                  />
                  <el-button
                    @click="editor(item, 'editor')"
                    size="36"
                    v-permission:editor="$route.meta.permission"
                    round
                    class="iconfont icon-bianji"
                  />
                  <el-button
                    @click="editor(item, 'details')"
                    size="36"
                    round
                    v-permission:details="$route.meta.permission"
                    class="iconfont icon-chakanxiangqing d5"
                  />
                </div>
              </div>
            </div>
            <div class="fd">
              <span class="condition">分销商申请条件</span>
              <ul class="flex">
                <li class="flex-item">
                  <p class="money">
                    ￥<span class="num">{{ item.personalSales }}</span>
                  </p>
                  <p class="intro dot">个人月度</p>
                  <p class="intro">销售金额</p>
                </li>
                <li class="flex-item">
                  <p class="money">
                    ￥<span class="num">{{ item.teamSales }}</span>
                  </p>
                  <p class="intro dot">团队月度</p>
                  <p class="intro">销售金额</p>
                </li>
                <li class="flex-item" v-if="item.numberId === '1'">
                  <p class="money">
                    <span class="num">{{ item.secondNum }}</span>
                    人
                  </p>
                  <p class="intro dot">二级分销</p>
                  <p class="intro">商用户数</p>
                </li>
                <li class="flex-item" v-if="item.numberId !== '3'">
                  <p class="money">
                    <span class="num">{{ item.thirdNum }}</span>
                    人
                  </p>
                  <p class="intro dot">三级分销</p>
                  <p class="intro">商用户数</p>
                </li>
              </ul>
            </div>
          </div>
        </transition-group>
      </div>
      <el-button
        @click="addLevel"
        size="220"
        v-permission:add="$route.meta.permission"
        class="iconfont icon-xinzeng"
        round
        >新增等级
      </el-button>
    </div>
  </div>
</template>
<script>
import img1 from '@/assets/img/level1.png'
import img2 from '@/assets/img/level2.png'
import img3 from '@/assets/img/level3.png'

export default {
  name: 'level',
  data() {
    this.keyMap = {
      distributor_list: {
        name: 'list',
        level_id: 'levelId',
        number_id: 'numberId',
        level_name: 'name',
        secondary_distributor_number: 'secondNum',
        tertiary_distributor_number: 'thirdNum',
        review_type: 'reviewType',
        personal_monthly_sales: 'personalSales',
        team_monthly_sales: 'teamSales',
        image_url: 'imgUrl'
      }
    }
    return {
      list: []
    }
  },
  created() {
    this._getDistributorList({
      curpage: 1
    })
  },
  methods: {
    /**
     * 删除
     * @param id
     * @param index
     */
    del(id, index) {
      this.$confirm('是否删除分销商？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '删除',
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.api.delDistributorLevel({ level_id: id }).then(() => {
            this.$notify({
              type: 'success',
              message: '删除成功~！😁'
            })
            this.list.splice(index, 1)
          })
        })
        .catch()
    },

    /**
     * 获取分销等级列表
     * @param params
     * @private
     */
    _getDistributorList(params) {
      this.api.getDistributorLevelList(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.list = res.list
      })
    },

    /**
     * 静态图片
     * @param index
     * @private
     */
    _staticImg(index) {
      switch (index) {
        case '1':
          return img1
        case '2':
          return img2
        case '3':
          return img3
      }
    },
    /**
     * 新增等级
     */
    addLevel() {
      const len = this.list.length
      const numberId = this.list.map(v => {
        return v.numberId
      })
      if (len === 3) {
        this.$notify({
          type: 'warning',
          message: '最多新增三个等级~！😕'
        })
        return
      }
      this.$router.push({
        name: 'distributorAdd',
        query: {
          title: '新增',
          except: numberId
        }
      })
    },
    /**
     * 编辑等级
     * @param item
     * @param type
     */
    editor(item, type) {
      const router = obj => {
        this.$router.push({
          name: 'distributorAdd',
          ...obj
        })
      }
      switch (type) {
        case 'editor':
          router({
            query: {
              id: item.levelId,
              title: '编辑',
              imgUrl: item.imgUrl
            }
          })
          break
        case 'details':
          router({
            query: {
              id: item.levelId,
              title: '编辑',
              imgUrl: item.imgUrl,
              details: 1
            }
          })
          break
      }
    }
  }
}
</script>
<style lang="scss">
.distribution-level {
  min-width: 1680px;

  .box {
    margin-right: -1.3rem;
  }

  .item {
    width: calc(33.33% - 1.3rem);
    float: left;
    background-color: #fff;
    margin-right: 1.3rem;
    margin-bottom: 1.3rem;
  }

  .hd {
    display: flex;
    justify-content: space-between;
    padding: 0 7.4rem 3rem 6rem;
    text-align: center;
    border-bottom: 1px dashed colors('d8');

    img {
      width: 5.6rem;
    }

    .num {
      font-size: 1.8rem;
      color: colors('d5');
      font-weight: bold;
      margin-top: 0.9rem;
    }

    .operator {
      margin-top: 4.4rem;
      text-align: left;
    }

    .title {
      font-size: 1.3rem;
      font-weight: bold;
    }

    .tips {
      font-size: 0.9rem;
      color: colors('a4');
    }

    .table-wrapper {
      margin-top: 2rem;
    }
  }

  .fd {
    text-align: center;
    padding: 3rem 2rem 5rem;

    .condition {
      width: 11.3rem;
      height: 2.5rem;
      background-color: colors('bg-f3');
      border-radius: 1.3rem;
      display: inline-block;
      text-align: center;
      line-height: 2.5rem;
      margin-bottom: 3.6rem;
    }

    .flex {
      display: flex;

      .flex-item {
        flex: 1;

        .dot {
          @include dots(#ff3649, -1.3rem, 6px);
        }

        &:nth-child(2) {
          .dot {
            &:before {
              background-color: #d5b68a;
            }
          }
        }

        &:nth-child(3) {
          .dot {
            &:before {
              background-color: #373655;
            }
          }
        }

        &:nth-child(4) {
          .dot {
            &:before {
              background-color: #36b5ff;
            }
          }
        }
      }

      .money {
        margin-bottom: 1rem;
      }

      .num {
        font-size: 1.3rem;
        font-weight: bold;
      }

      .intro {
        color: colors('a4');
      }
    }
  }
}
</style>
